














































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import Papa from 'papaparse'
import md5 from 'crypto-js/md5'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import api from 'src/assets/api/gql'
import ContactCreate from 'src/graphql/contact/ContactCreate.gql'
import ContactUpdate from 'src/graphql/contact/ContactUpdate.gql'
import ContactGroupCreate from 'src/graphql/contact_group/ContactGroupCreate.gql'
import { Contact, ContactGroup } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen
  }
})
export default class ContactButtonAdd extends Vue {
  off = false
  csv = ''
  file: File | null = null
  result = {
    total: 0,
    done: 0,
    errors: 0,
    duplicates: 0,
    notfound: 0,
    found: 0,
    groups: 0
  }

  @Prop()
  readonly groups!: ContactGroup[]

  @Ref()
  readonly dialog!: DialogFullscreen

  get groupsMap () {
    return new Map(this.groups.map(g => [g.name, g.id.toString()]))
  }

  action () {
    this.off = false
    this.result = {
      total: 0,
      done: 0,
      errors: 0,
      duplicates: 0,
      notfound: 0,
      found: 0,
      groups: 0
    }
    this.dialog.show()
  }

  exit () {
    this.off = true
    this.csv = ''
    this.file = null
    this.dialog.hide()
  }

  load (file: File) {
    const reader = new FileReader()
    reader.addEventListener('load', (event) => {
      this.csv = event.target?.result?.toString() || ''
    });
    reader.readAsText(file);
  }

  async add () {
    const csv = Papa.parse(this.csv, {
      skipEmptyLines: 'greedy',
      transform: (x: string) => x.trim()
    })
    this.result.total = csv.data.length
    for (const row of csv.data as string[][]) {
      const name = row.shift()
      const email = row.shift()
      const groups = row
      if (name && email && email.match(/^[a-zA-Z0-9\.\-\_]+@([a-zA-Z0-9\-\_]+\.)+[a-zA-Z]+$/)) {
        const contact = await this.addContact(name, email)
        if (contact) {
          if (contact.contactPersonId) {
            this.result.found++
          } else {
            this.result.notfound++
          }
          await this.setContactGroups(contact, groups)
        } else {
          this.result.duplicates++
        }
      } else {
        this.result.errors++
      }
      this.result.done++
      if (this.off) break
    }
    if (this.result.found || this.result.notfound) this.$emit('import')
  }

  async addContact (name: string, email: string) {
    const emailMatch = email.toLowerCase().match(/^(.)(.?)(.*?)(.?)@(.)(.?)(.*?)(.?)(\.[^\.]+)$/) || []
    const contactEmailMask =
      (emailMatch[2] ? emailMatch[1] : '') +
      (emailMatch[4] ? emailMatch[2] : '') +
      '..' +
      (emailMatch[3].length < 3 ? '' : emailMatch[4]) +
      '@' +
      emailMatch[5] +
      (emailMatch[8] ? emailMatch[6] : '') +
      (emailMatch[8] ? '..' : '') +
      (emailMatch[7].length < 3 ? '' : emailMatch[8]) +
      emailMatch[9]
    const contactEmailHash = md5(email.toLowerCase()).toString()
    const { data: { createContact } } = await api.mutate({
      query: ContactCreate,
      variables: { name, contactEmailHash, contactEmailMask }
    })
    return createContact?.contact
  }

  async setContactGroups (contact: Contact, groups: string[]) {
    const contactGroups: string[] = []
    for (const name of groups) {
      if (!this.groupsMap.has(name)) {
        await this.addGroup(name)
      }
      const id = this.groupsMap.get(name)
      if (id) {
        contactGroups.push(id)
      }
    }
    if (contactGroups.length) {
      await api.mutate({
        query: ContactUpdate,
        variables: {
          id: contact.id,
          data: { contactGroups }
        }
      })
    }
  }

  async addGroup (name: string) {
    const { data: { createContactGroup } } = await api.mutate({
      query: ContactGroupCreate,
      variables: { name }
    })
    const group = createContactGroup?.contactGroup
    if (group) {
      this.result.groups++
      this.$emit('create-group', group)
    }
    return group
  }
}
